import { render, staticRenderFns } from "./SelectPlayer.vue?vue&type=template&id=5a87ff42&scoped=true"
import script from "./SelectPlayer.vue?vue&type=script&lang=js"
export * from "./SelectPlayer.vue?vue&type=script&lang=js"
import style0 from "./SelectPlayer.vue?vue&type=style&index=0&id=5a87ff42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87ff42",
  null
  
)

export default component.exports